module.exports = __webpack_public_path__ + "static/media/mobile-services-item-explore-bg.1eb8da98.svg";